import React from 'react';

import FileIcon from '@mui/icons-material/FileCopy';
import FolderIcon from '@mui/icons-material/Folder';
import EmailIcon from '@mui/icons-material/Email';
import ReportIcon from '@mui/icons-material/PieChart';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import DomainIcon from '@mui/icons-material/Domain';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import WorkIcon from '@mui/icons-material/Work';
import PeopleIcon from '@mui/icons-material/People';
import AddIcon from '@mui/icons-material/Add';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import TerminalIcon from '@mui/icons-material/Terminal';
import NextPlanIcon from '@mui/icons-material/NextPlan';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import ScheduleIcon from '@mui/icons-material/Schedule';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

const style = {
    fontSize: '1rem',
    marginRight: 4
};

const fontawesomeStyle = {
    fontSize: 14,
    marginRight: 4,
    width: 16
}

class EnumTypeIcon extends React.Component {
    render() {
        const { type } = this.props;
        switch (type) {
            case 'Certification':
                return <WorkspacePremiumIcon style={{ ...style }} />
            case 'DeliveryDining':
                return <DeliveryDiningIcon style={{ ...style }} />
            case 'LocalShipping':
                return <LocalShippingIcon style={{ ...style }} />
            case 'Add':
                return <AddIcon style={{ ...style }} />
            case 'AddTicket':
                return <AddCircleIcon style={{ ...style, fill: '#D90010' }} />
            case 'AddInternalTicket':
                return <AddCircleIcon style={{ ...style, fill: '#045a8e' }} />

            case 'Email':
                return <EmailIcon style={{ ...style }} />
            case 'Local':
                return <DomainIcon style={{ ...style }} />
            case 'SystemUser':
                return <KeyboardIcon style={{ ...style }} />
            case 'Report':
                return <ReportIcon style={style} />
            case 'Setting':
                return <SettingsIcon style={{ ...style }} />
            case 'WorkIcon':
                return <WorkIcon style={{ ...style }} />
            case 'Project':
                return <WorkIcon style={{ ...style, fill: '#045a8e' }} />
            case 'Folder':
                return <FolderIcon style={{ ...style, fill: '#ecd31f' }} />
            case 'TicketMyObsPending':
                return <InsertCommentIcon style={{ ...style }} />
            case 'TicketAllOpen':
                return <PeopleIcon style={{ ...style }} />
            case 'People':
                return <PeopleIcon style={{ ...style, fill: '#36c2f6' }} />
            case 'Person1':
                return <PersonIcon style={{ ...style, fill: '#36c2f6' }} />
            case 'Person2':
                return <PersonIcon style={{ ...style, fill: '#20b3b3' }} />
            case 'Person3':
                return <PersonIcon style={{ ...style, fill: '#f39858' }} />
            case 'Person4':
                return <PersonIcon style={{ ...style, fill: '#4f45ea' }} />
            case 'Person5':
                return <PersonIcon style={{ ...style, fill: '#9B02D6' }} />
            case 'PostService':
                return <NextPlanIcon style={{ ...style }} />
            case 'TicketInternalAll':
                return <TerminalIcon style={{ ...style, fill: '#045a8e' }} />
            case 'TicketOpen':
                return <FileIcon style={{ ...style, fill: '#DF7B00' }} />
            case 'TicketClientAll':
                return <SupportAgentIcon style={{ ...style, fill: '#D90010' }} />
            case 'TicketAllMyOpen':
                return <PersonIcon style={{ ...style, fill: '#D90010' }} />
            case 'TicketMyOpen':
                return <FileIcon style={{ ...style, fill: '#D90010' }} />
            case 'TicketClosed':
                return <FileIcon style={{ ...style, fill: '#045a8e' }} />
            case 'NotAnalyzed':
                return <NextPlanIcon style={{ ...style, fill: '#D90010' }} />
            case 'Pending':
                return <NextPlanIcon style={{ ...style, fill: '#DF7B00' }} />
            case 'Concluded':
                return <NextPlanIcon style={{ ...style, fill: '#045a8e' }} />
            case 'ProjectNotAnalyzed':
                return <WorkIcon style={{ ...style, fill: '#D90010' }} />
            case 'ProjectPending':
                return <WorkIcon style={{ ...style, fill: '#DF7B00' }} />
            case 'ProjectPendingVip':
                return <WorkIcon style={{ ...style, fill: 'rgb(236, 211, 31)' }} />
            case 'ProjectConcluded':
                return <WorkIcon style={{ ...style, fill: '#045a8e' }} />
            case 'Schedule':
                return <ScheduleIcon style={{ ...style }} />
            default:
                return <FileIcon style={style} />;
        }
    }
}

export default EnumTypeIcon;